// employees/EmployeeContext.js
import { getAllDocumentApi,getAllDocumentTypeApi } from "api/services/documents";
import { format } from "date-fns";
import { createContext,useCallback,useContext,useEffect,useMemo,useState } from 'react';
import { useMediaQuery } from "react-responsive";
import { useLocation,useNavigate,useParams,useSearchParams } from 'react-router-dom';
import { filterHandler } from 'utils/common';
import { defaultPagination,handlePageChange } from "utils/table";
import useDocumentFilter from "../hooks/filterHook";


							
									  

// Create the Document context
const documentContext = createContext();

// Custom hook for accessing Document context easily
export const useDocument = () => {
  return useContext(documentContext); 
};

// DocumentProvider component to wrap around components needing access to Resume data
export const DocumentProvider = ({ children }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    let params = useParams()
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const location = useLocation();

    const navigate = useNavigate()

  
  const [loading, setLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(0);
												   
  const [documentModal, setDocumentModal] = useState(false);
  const [ selectedDocument, setSelectedDocument] = useState(false);
  const [documentData, setDocumentData] = useState([]);
  const [view, setView] = useState(isMobile? "grid":"list");
  const [storeType, setStoreType] = useState(window.location.pathname.includes("store") ? "store" : "user");

  const [showFilterDrawer, setShowFilterDrawer] = useState(false)
  const [documentType, setDocumentType] = useState([])
  const [documentTypeLoading, setDocumentTypeLoading] = useState(false)

  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_by") || "",
    document_type: searchParams.get("document_type") ,
    // document_sub_type: searchParams.get("document_sub_type") ,
    user: searchParams.get("company_user")

    //document_type=user&document_sub_type=passport&user=1&issue_date_after=2025-10-28&issue_date_before=2025-10-29&expiry_date_after=2025-10-30&expiry_date_before=2025-10-30&sort_type=ascend&sort_by=issue_date&expiry_in=365
})
const { handleFilterChange,
    filters,
    handleInputChange, filterLoading, setFilterLoading, handleDateChange} = useDocumentFilter(pageSettings , setPageSettings, documentType);

const getFilterParams = useCallback(()=>{
  let filter_params = filterHandler(filters)
    return filter_params

})

const getExportParams = useCallback(() => {
  let filter_params = getFilterParams()
  if (filter_params?.issue_date_after) {
    filter_params.issue_date_after = format(new Date(filter_params.issue_date_after), "yyyy-MM-dd")
  }
  if (filter_params?.issue_date_before) {
    filter_params.issue_date_before = format(new Date(filter_params.issue_date_before), "yyyy-MM-dd")
  }
  if (filter_params?.expiry_date_after) {
    filter_params.expiry_date_after = format(new Date(filter_params.expiry_date_after), "yyyy-MM-dd")
  }
  if (filter_params?.expiry_date_before) {
    filter_params.expiry_date_before = format(new Date(filter_params.expiry_date_before), "yyyy-MM-dd")
  }
  return {
    sort_by: pageSettings?.sortBy,
    sort_type: pageSettings?.sortType,
    document_type: pageSettings?.document_type,
    document_sub_type: pageSettings?.document_sub_type,
    company_user: pageSettings?.user || pageSettings?.userData,
    document_type__type: storeType,
    ...filter_params,
  }
}, [filters, pageSettings, storeType])

const setDocumentParams = (pageData) => {
    let filter_params = getFilterParams()
    let params = {
        size: pageData?.pageSize,
        page: pageData?.page,
        sort_by: pageData?.sortBy || "",
        sort_type: pageData?.sortType || "",
        ...filter_params
    }
    setSearchParams(params)
}



    const getDocumentList = useCallback(() => {
        setLoading(true)
        setFilterLoading(true)      
        let filter_params = getFilterParams()
          if(filter_params?.issue_date_after){
            filter_params.issue_date_after = format(new Date(filter_params.issue_date_after), "yyyy-MM-dd")
        }
        if(filter_params?.issue_date_before){
          filter_params.issue_date_before = format(new Date(filter_params.issue_date_before), "yyyy-MM-dd")
         }

        if(filter_params?.expiry_date_after){
            filter_params.expiry_date_after = format(new Date(filter_params.expiry_date_after), "yyyy-MM-dd")
        }
        if(filter_params?.expiry_date_before){
            filter_params.expiry_date_before = format(new Date(filter_params.expiry_date_before), "yyyy-MM-dd")
        }


          
        getAllDocumentApi({         
          sort_by:pageSettings?.sortBy,
          sort_type: pageSettings?.sortType,
          page_size: pageSettings?.pageSize,
          page: pageSettings?.page,
          document_type: pageSettings?.document_type,
          document_sub_type: pageSettings?.document_sub_type,
          company_user: pageSettings?.user || pageSettings?.userData,
          document_type__type: storeType,
          ...filter_params    
        }).then(response=>{
          if(view=="grid" && pageSettings?.page!==1){
            setDocumentData([...documentData,...response.data.results]);

          }else{
            setDocumentData(response.data.results);

          }

          
          setPageSettings(prev => ({
            ...prev,
            total: response.data.count
          }))
    
          setLoading(false)
          setFilterLoading(false)
          setShowFilterDrawer(false)
        }).catch(e=>{
          setLoading(false)
          setFilterLoading(false)
        })
    }, [pageSettings, storeType, view, documentData, getFilterParams])
  useEffect(()=>{

    console.log(window.location.pathname, "#########")
    getDocumentList()

  },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters, pageSettings?.user, pageSettings?._resetTimestamp, storeType])

  useEffect(()=>{
    setDocumentParams(pageSettings)
  },[pageSettings])

  useEffect(()=>{
    setDocumentTypeLoading(true)
    getAllDocumentTypeApi({type:storeType}).then(response=>{
      setDocumentType(response.data.results)
      setDocumentTypeLoading(false)
    }).catch(e=>{
      setDocumentTypeLoading(false)
    })
  },[storeType])

  const handleApplyFilter = () => {
    setPageSettings({
        ...pageSettings,
        page: 1,
        filters
      })

  }


  const handleGridChange = (page, size) =>{
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })				 
			 
	
  }


  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
    console.log(pageData)
    setPageSettings(pageData)
  }; 
							
		
  

  const handleFilterDrawer = () => {
    console.log("JJJJJJJ")
    setShowFilterDrawer(!showFilterDrawer)
    setFilterLoading(false)
  }



  const handleDocumentDetailPage = (id, index) => {			  
    // Include type in query params to maintain navigation state
    const typeParam = storeType === 'store' ? 'type=store' : 'type=user';
    navigate(`/documents/${id}?${typeParam}`)
    setSelectedPage(index)
  }



  const resetDocumentList = useCallback(() => {
    console.log("***************** Resetting document list")
    setDocumentData([])
    const companyUserParam = searchParams.get("company_user");
    const newPageSettings = {
      ...defaultPagination,
      page: searchParams.get("page") || 1,
      pageSize: searchParams.get("size") || 50,
      sortType: searchParams.get("sort_type") || "",
      sortBy: searchParams.get("sort_by") || "",
      document_type: searchParams.get("document_type") || null,
      // document_sub_type: searchParams.get("document_sub_type") ,
      user: companyUserParam || null,
      total: 0
    }
    // Use functional update and add a timestamp to force re-render
    setPageSettings(prev => ({
      ...newPageSettings,
      _resetTimestamp: Date.now() // Force update to trigger useEffect
    }))
  }, [searchParams])

  // Reset document list when navigating to documents list page
  useEffect(() => {
    // Check if we're on the documents list page (not detail page)
    const isDocumentListPage = location.pathname === '/documents' || location.pathname === '/documents/';
    const isStoreDocumentsPage = location.pathname === '/documents/store' || location.pathname === '/documents/store/';
    
    if (isDocumentListPage || isStoreDocumentsPage) {
      const currentUser = searchParams.get("company_user");
      const hasUserFilter = pageSettings?.user;
      const expectedStoreType = isStoreDocumentsPage ? 'store' : 'user';
      
      // First, ensure storeType is correct
      if (storeType !== expectedStoreType) {
        console.log("Setting storeType - storeType mismatch", { storeType, expectedStoreType });
        setStoreType(expectedStoreType);
        // Don't reset here, let the storeType change trigger the fetch
        // Then reset will happen on next render
        return;
      }
      
      // Then check if we need to reset
      // Always reset when navigating to documents list page if:
      // 1. We have a user filter in state but URL doesn't have it (coming from detail page with filters)
      // 2. Document data is empty and we're not loading (state got corrupted)
      // This ensures clean state when navigating from detail pages
      if ((hasUserFilter && !currentUser)) {
        console.log("Resetting document list - clearing user filter", { hasUserFilter, currentUser });
        resetDocumentList();
      } else if (documentData.length === 0 && !loading && pageSettings?.total === 0 && !currentUser) {
        console.log("Resetting document list - empty state", { dataLength: documentData.length });
        resetDocumentList();
      }
    }
  }, [location.pathname, searchParams, storeType, resetDocumentList])
  // Value to be provided to context consumers
  // Memoize the context value to avoid unnecessary re-renders
  const value = useMemo(() => ({
    documentData, setDocumentData,
    loading, setLoading,
   
    view, setView,
    pageSettings , setPageSettings,
    showFilterDrawer, setShowFilterDrawer,

    filterLoading, setFilterLoading,
    selectedPage, setSelectedPage,

    documentModal, setDocumentModal,
    selectedDocument, setSelectedDocument,

    handleGridChange,
    handleChange,

    handleFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    handleDocumentDetailPage,
    handleDateChange,
    getDocumentList,

    documentType, setDocumentType,
    storeType, setStoreType,
    documentTypeLoading,

    resetDocumentList,
    getExportParams,

  }), [documentData , view, loading, pageSettings, showFilterDrawer, filters, filterLoading, selectedPage, documentModal, selectedDocument, documentType, storeType, documentTypeLoading, getExportParams]);

  return (
    <documentContext.Provider value={value}>
      {children}
    </documentContext.Provider>
  );
};